export enum PublicErrorCode {
  // PUBLIC FOSSA ERRORS 3000 - 4000
  // These error codes and names are available to front-end code
  orgNameAlreadyExists = 3001,
  userAlreadyInOrg = 3002,
  ssoRequired = 3003,
}
